var map = {
	"./icon-aep.svg": "2a4c",
	"./icon-ai.svg": "f4f1",
	"./icon-doc.svg": "d869",
	"./icon-error.svg": "b266",
	"./icon-figma.svg": "68fa",
	"./icon-mp4.svg": "2aa2",
	"./icon-otf.svg": "76e4",
	"./icon-png.svg": "1757",
	"./icon-row.svg": "b27d",
	"./icon-success.svg": "9bad",
	"./icon-woff.svg": "cd0c",
	"./icon-zip.svg": "e428"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1db3";